// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"02e0ed2c","232":"c20701e4","237":"ca667d16","526":"7e01f3bd","787":"28d506df"}[chunkId] + ".chunk.js";
};